import { render, staticRenderFns } from "./AdsSelect.vue?vue&type=template&id=9e05f638&scoped=true&"
import script from "./AdsSelect.vue?vue&type=script&lang=js&"
export * from "./AdsSelect.vue?vue&type=script&lang=js&"
import style0 from "./AdsSelect.vue?vue&type=style&index=0&id=9e05f638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e05f638",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
